<mat-nav-list [class]="themeCss">
  <ul id="first">
    <li *ngFor="let item of list" mat-list-item>
      <ng-container *ngIf="!item.removed" [ngTemplateOutlet]="menuItem"
        [ngTemplateOutletContext]="{item:item, level:1}"></ng-container>
    </li>
  </ul>
</mat-nav-list>

<ng-template #menuItem let-item='item' let-level='level'>
  <!-- link -->
  <a class="item-menu" [routerLink]="item.link !== 'logout' ? item.link : null" [routerLinkActive]="['is-active']"
    (click)="onItemClick(item)" [class.show]="item.show" [class.hide]="!item.show" [class]="'level-'+level"
    [class.collapsed]="item.collapse" appTooltip="{{ 'MenuTooltips.'+item.id | translate}}">
    <mat-icon color="primary" [matBadge]="item.chip" [appTooltip]="item.chipText" [matBadgePosition]="'above after'"
      matBadgeColor="warn" [matBadgeSize]="'small'">{{item.icon}}</mat-icon>
    <span class="main-menu-item-text">{{item.title}}</span>
    <mat-icon *ngIf="item.showIconCollapse" class="btn-collapse"
      (click)="toggleCollapse($event, item)">chevron_right</mat-icon>
  </a>
  <!-- submenu -->
  <ng-container *ngIf="item.childs">
    <ul class="wrap-level-{{level+1}}">
      <li *ngFor="let subItem of item.childs">
        <ng-container *ngIf="!subItem.removed" [ngTemplateOutlet]="menuItem"
          [ngTemplateOutletContext]="{item:subItem, level:level+1}"></ng-container>
      </li>
    </ul>
  </ng-container>
</ng-template>
